import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddAreabeetMasterComponent } from "./addareabeetemaster/addareabeetmaster.component";
import { AddChemistMasterComponent } from "./addchemistmaster/addchemistmaster.component";
import { AddEmployeeMasterComponent } from "./addemployeemaster/addemployeemaster.component";
import { AddHQMasterComponent } from "./addhqemaster/addhqmaster.component";
import { AreaBeetMasterComponent } from "./areabeetmaster/areabeetmaster.component";
import { AreaListMasterComponent } from "./arealistmaster/arealistmaster.component";
import { ChemistMasterComponent } from "./chemistmaster/chemistmaster.component";
import { EmployeeMasterComponent } from "./employeemaster/employeemaster.component";
import { ExpenseMasterComponent } from "./expensemaster/expensemaster.component";
import { HqMasterComponent } from "./hqmaster/hqmaster.component";
import { ProductPriceListComponent } from "./productpricelist/productpricelist.component";
import { RouteListComponent } from "./routelist/routelist.component";
import { RouteMasterComponent } from "./routemaster/routemaster.component";
import { StockistMasterComponent } from "./stockistmaster/stockistmaster.component";
import {chemistregresetComponent} from "./chemistmaster/chemistregreset.component";
import {ChemistListTransfer} from "./chemistlisttransfer/chemistlisttransfer.component";
import {QPSschemeMasterComponent} from "./qpsschememaster/qpsschememaster.component";
import { AuthGuard } from '../../components/auth/auth-guard.service';





const mainRoutes: Routes = [

    { path: 'employeemaster', canActivate: [AuthGuard], component: EmployeeMasterComponent },
    { path: 'addemployeemaster', canActivate: [AuthGuard], component: AddEmployeeMasterComponent },
    { path: 'hqemployeemaster', canActivate: [AuthGuard], component: HqMasterComponent },
    { path: 'addhqmaster', canActivate: [AuthGuard], component: AddHQMasterComponent },
    { path: 'areabeetemployeemaster', canActivate: [AuthGuard], component: AreaBeetMasterComponent },
    { path: 'chemistmaster', canActivate: [AuthGuard], component: ChemistMasterComponent },
    { path: 'addchemistmaster', canActivate: [AuthGuard], component: AddChemistMasterComponent },
    { path: 'addareabeetmaster', canActivate: [AuthGuard], component: AddAreabeetMasterComponent },
    { path: 'stockistmaster', canActivate: [AuthGuard], component: StockistMasterComponent },
    { path: 'expensemaster', canActivate: [AuthGuard], component: ExpenseMasterComponent },
    { path: 'productpricelist', canActivate: [AuthGuard], component: ProductPriceListComponent },
    { path: 'routemaster', canActivate: [AuthGuard], component: RouteMasterComponent },
    { path: 'routelist', canActivate: [AuthGuard], component: RouteListComponent },
    { path: 'arealistmaster', canActivate: [AuthGuard], component: AreaListMasterComponent },
    {path: 'chemistregreset', canActivate: [AuthGuard], component: chemistregresetComponent},
    {path: 'chemistlisttransfer', canActivate: [AuthGuard], component: ChemistListTransfer},
    {path: 'qpsschememaster', canActivate: [AuthGuard], component: QPSschemeMasterComponent},

]
@NgModule({
    imports: [RouterModule.forChild(mainRoutes)],
    exports: [RouterModule]
})
export class MasterRoutingModule {

}